export default "__VITE_ASSET__CLsWG7YM__"